import { useParams } from "react-router-dom";
import PublicTransportVectorTileLayer from "./layers/PublicTransportVectorTileLayer";
import { MapView } from "../../../../constant/VectorTileLayerType";
import AdminLogBoundaries from "./interractions/AdminLogBoundaries";

const PtBoundaryMapView = () => {
  const visible = useParams().layer === MapView.PT_BOUNDARIES;

  return (
    <>
      <PublicTransportVectorTileLayer visible={visible} />
      <AdminLogBoundaries />
    </>
  );
};

export default PtBoundaryMapView;
